window.addEventListener('DOMContentLoaded', () => {
  const mainVisual: HTMLElement | null = document.getElementById('mainVisual')
  const fixedLogo: HTMLElement | null = document.getElementById('fixedLogo')
  if (mainVisual && fixedLogo) {
    if (window.scrollY > mainVisual.clientHeight) {
      fixedLogo.classList.add('active')
    }
    window.addEventListener('scroll', () => {
      const scrollHeight = document.documentElement.scrollTop
      if (scrollHeight > mainVisual.clientHeight) {
        fixedLogo.classList.add('active')
      } else {
        fixedLogo.classList.remove('active')
      }
    })
  } else if (fixedLogo) {
    fixedLogo.classList.add('active')
  }
})
